import { Grid } from '@mui/material';

import { useTableFilter } from '@/shared';
import { usefetchCostos } from '@/shared/actions/erp';
import { GeneralTable } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum, CategoriaFCorporativaEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { useClientesCorporativosCostosColumns } from '../tables/ClientesCorporativosCostosColumns';
import { Costos } from '@/shared/interfaces/erp/activos/costo-activo.interface';

export type AgregarCostoModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};



// Solo es una solicitud de actualización - NO bloquea el flujo
const AgregarCostoModal: React.FC<AgregarCostoModalProps> = ({
    open,
    onClose,
    onConfirm,
  // preagendamiento,
}) => {

    ///* fetch data --------------------
    // const {
    //     data: motivosRechazoPaging,
    //     isLoading: isLoadingMotivosRechazo,
    //     isRefetching: isRefetchingMotivosRechazo,
    // } = useFetchMotivosRechazo({
    //     estado: true,
    //     modulo: ModulosEnumChoice.PREAGENDAMIENTO,
    //     page_size: 100,
    // });

  /////* global state ==============================
  const setAlert = useUiStore(s => s.setAlert);
  // rubro table -------------
  const addSelectedItem = useMaterialesUtilizadosStore(
    s => s.addSelectedItemCustomKey
  );
  const {
    // globalFilter,
    pagination,
    // onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  const {
    data: CostosPagingRes,
    isLoading,
    isRefetching,
  } = usefetchCostos({
    page: pageIndex + 1,
    page_size: 10,
  });

  const {clientesCorporativosCostosColumns} = useClientesCorporativosCostosColumns()

  const dataPrueba : Costos[] = [
    {
      id_costo: "idunicocodigopruebacosto",
      codigo: "codigopruebacosto",
      numero_referencia: "182367",
      tipo_producto: "TipoProducto",
      nombre: "Costo de Prueba",
      costo: 176,
      cif: 6,
      mano_obra_directa	: 150,
      mano_obra_indirecta: 20,
      estado: true,
      cuentas_contables: "aqjkw-hekjqh-qwkjeh-q123qwkj",
    }
  ]






  ///* effects --------------------
//   useLoaders(isLoadingMotivosRechazo || isRefetchingMotivosRechazo);

  return (
    <ScrollableDialogProps
      open={open}
      title="Agregar Costo"
      rejectTextBtn={"Cerrar"}
      minWidth="70%"
      onClose={() => {
        onClose();
        //formRechazo.setValue('isRejecting', false);
        // formRechazo.reset({
        //   ...formRechazo.getValues(),
        //   motivo_rechazo: '',
        //   isRejecting: false,
        // });
      }}
      onConfirm={onConfirm}
    //   confirmTextBtn="SI"
    //   cancelTextBtn="NO"

      showConfirmBtn={false}
    //   confirmVariantBtn="outlined"
      contentNode={
        <Grid item container xs={12} mb={3} spacing={3} p={4}>
            <Grid>

            </Grid>
            {/* ----------- table ----------- */}
            <Grid item container xs={12} spacing={3} my={2}>
              <GeneralTable<Costos>
                columns={clientesCorporativosCostosColumns}
                data={dataPrueba || CostosPagingRes?.data?.data || []}
                isLoading={isLoading}
                isRefetching={isRefetching}
                // // search
                enableGlobalFilter={false}
                // // pagination
                pagination={pagination}
                onPaging={setPagination}
                rowCount={CostosPagingRes?.data?.count}
                // // actions ========
                enableColumnActions={true}
                canEdit={false}
                canAdd={true}
                onAdd={costo => {
                    // const firstPrice = ubicProd?.producto_data?.precios?.[0]?.precio || '0.00';

                    // // const contieneSeries = ubicProd?.series?.length > 0;
                    // // const { id, ...ubiProdRestante } = ubicProd;
                    // {
                    //   id_costo: "idunicoasjkdhaskj",
                    //   codigo: "codigoprueba",
                    //   numero_referencia: "182367",
                    //   tipo_producto: "TipoProducto",
                    //   nombre: "Costod de Prueba",
                    //   costo: 176,
                    //   cif: 6,
                    //   mano_obra_directa	: 150,
                    //   mano_obra_indirecta: 20,
                    //   estado: true,
                    //   cuentas_contables: "aqjkw-hekjqh-qwkjeh-q123qwkj",
                    // }
                    addSelectedItem(
                        {
                          codigo: costo.id_costo!,
                          nombre: costo.nombre!,
                          precioUnitario: costo.costo!,
                          cantidad: 1,
                          total: costo.costo!,
                          subtotal: costo.costo,
                          ivaCode: "IVA 0%",
                          ivaValue: 0, // 15% de 50
                          precioLibre: true,
                          preciosDisponibles: [],
                          categoria_fcorporativa: CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                        },
                        MaterialesKey.selectedItems, 'codigo', false, false
                    );
                    setAlert(
                        true,
                        'Costo añadido',
                        AlertSeverityEnum.success
                    );
                }}
              />
            </Grid>



          {/* <Grid item xs={12}>
            <Typography variant="body1">
              Para enviar a Gestión Ventas el preagendamiento es necesario seleccionar el motivo de rechazo. 
              ¿Desea continuar?
            </Typography>
          </Grid>
          
          <CustomAutocomplete<MotivoRechazo>
            label="Motivo de rechazo"
            name="motivo_rechazo"
            // options
            options={motivosRechazoPaging?.data?.data || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={formRechazo.getValues().motivo_rechazo || ''}
            isLoadingData={
              isLoadingMotivosRechazo || isRefetchingMotivosRechazo
            }
            // validation
            control={formRechazo.control}
            error={formRechazo?.formState?.errors.motivo_rechazo}
            helperText={
              !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
              'El motivo de rechazo es requerido'
            }
            disableClearable
          />


          <CustomTextArea
            label="Observación de rechazo"
            name="observacion_rechazo"
            required={false}
            control={formRechazo.control}
            error={formRechazo?.formState?.errors.observacion_rechazo}
            helperText={"Detalles adicionales sobre el rechazo"}
          /> */}
        </Grid>
      }
    />
  );
};

export default AgregarCostoModal;
